module.exports = __webpack_public_path__ + "static/bottom-cad6b58b919e04b81cb532a5c79403a9.png";